import { withStyles } from '@material-ui/core';

import styles from '@/components/FilterBar/styles';

import FilterBar from './component';

export default withStyles(styles)(FilterBar);
